import axiosInstance from "./api";
import TokenService from "./token.service";
import StockAccessService from "./stock-access.service";
import router from '@/router'

// Screens opened from a public branch link: staff reach them without signing
// in, so a 401 from one of their calls is not an expired session. Logging out
// and bouncing to /sign-in there throws away a merchant session that may well
// be valid, and strands whoever was using the link.
const PUBLIC_BRANCH_ROUTES = [
  "Stock",
  "StockByPhysicalBranch",
  "KdsDirectLink",
  "Order",
];

const setup = () => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      }
      var merchantId = localStorage.getItem('MERCHANT_ID', '');
      var merchantCode = localStorage.getItem('MERCHANT_CODE', '');
      if(merchantCode != "") {
        config.headers["MerchantCode"] = merchantCode;  // for Spring Boot back-end
      }
      if(merchantId != "") {
        config.headers["MerchantId"] = merchantId;  // for Spring Boot back-end
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      StockAccessService.captureRenewal(res);
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      const routeName = router?.currentRoute?.value?.name;
      if (
        err.response &&
        err.response.status === 401 &&
        !originalConfig._retry &&
        !PUBLIC_BRANCH_ROUTES.includes(routeName)
      ) {
        TokenService.removeUser();
        router.push('/sign-in');
      }
      // if (originalConfig.url !== "/auth/login" && err.response) {
      //   // Access Token was expired
      //   if (err.response.status === 401 && !originalConfig._retry) {
      //     originalConfig._retry = true;

      //     try {
      //       const rs = await axiosInstance.post("/auth/refreshtoken", {
      //         refreshToken: TokenService.getLocalRefreshToken(),
      //       });

      //       const { accessToken } = rs.data;

      //       store.dispatch('auth/refreshToken', accessToken);
      //       TokenService.updateLocalAccessToken(accessToken);

      //       return axiosInstance(originalConfig);
      //     } catch (_error) {
      //       return Promise.reject(_error);
      //     }
      //   }
      // }

      return Promise.reject(err);
    }
  );
};

export default setup;